// src/utils/get-keys.ts
function getKeys(obj) {
  return Object.keys(obj);
}

export {
  getKeys
};
//# sourceMappingURL=chunk-4MXCHP7N.mjs.map